exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".sales-btn{padding:8px 16px;text-transform:none;font-weight:700}.white-text{color:#fff}", "", {"version":3,"sources":["/opt/buildhome/repo/src/pages/template/page-distribution-of-resources.vue"],"names":[],"mappings":"AACA,WACE,iBAAkB,AAClB,oBAAqB,AACrB,eAAkB,CACnB,AACD,YACI,UAAa,CAChB","file":"page-distribution-of-resources.vue","sourcesContent":["\n.sales-btn {\n  padding: 8px 16px;\n  text-transform: none;\n  font-weight: bold;\n}\n.white-text {\n    color: white;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ca1a8178","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/template/page-distribution-of-resources.vue
// module id = 1056
// module chunks = 18